export function getResultOfInputRules(
  rules: Array<(a: any) => boolean | string> | undefined,
  payload: any,
) {
  if (!rules) return null;
  const res = rules.map(rule => rule(payload)).filter(v => typeof v === 'string');
  return res.length > 0 ? res[0] : null;
}
